import { render, staticRenderFns } from "./BillingDetails.vue?vue&type=template&id=10a922e5&scoped=true"
import script from "./BillingDetails.vue?vue&type=script&lang=js"
export * from "./BillingDetails.vue?vue&type=script&lang=js"
import style0 from "./BillingDetails.vue?vue&type=style&index=0&id=10a922e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a922e5",
  null
  
)

export default component.exports